(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["lead-popup"]) return;
  try {
    
$(document).ready(function(){
  console.log("30 seconds");
   if($.cookie('pop-up') != 'seen'){
       $(".pop-up").delay(30000).fadeIn();
       var detached = $('#shopify-section-mc_newsletter').detach();
       $('#shopify-section-lead-popup').addClass('fade');
       $('.close').click(function(e)
        {
             $.cookie('pop-up', 'seen', { expires: 30, path: '/' });
             $('.pop-up').fadeOut();
             $('#shopify-section-frontpage').after().append(detached);
             console.log("appended 1");
         });
       $('.newsletter__submit').click(function(e)
           {
             if( $('#mce-EMAIL').val().length === 0 ) {
               console.log("inside validate ");
                 $("#mce-EMAIL").addClass('required');
                 $("#mce-EMAIL").focus();

                 $("input[name='EMAIL']").blur(function(){
                  $(this).removeClass('required');
                  $("#mce-success-response").addClass('success');
                 });
                 return false;
             }
             if ( $("#mce-success-response").hasClass("success") ) {

             	}
              $.cookie('pop-up', 'seen', { expires: 365, path: '/' });
              $('.pop-up').delay(2000).fadeOut();
              $('#shopify-section-frontpage').after().append(detached);


       });
   };
    if ($(window).width() > 590) {
     console.log("greater than 590px");
    }

    if ($(window).width() < 590) {
      console.log("less than 590px");
      $("#mce-EMAIL").focus(function(){
          $(".modal_content_wrapper").css("margin-top", "-250px");
      });
      $("#mce-EMAIL").focusout(function(){
          $(".modal_content_wrapper").css("margin-top", "0px");
      });
    }

});

  } catch(e) { console.error(e); }
})();

})();
